import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRound = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 7a8 8 0 00-8 8H4C4 8.925 8.925 4 15 4v3z"
	})
});
export default SvgRound;
